import { INVENTORY_REQUEST_SUBMISSION_STATUS } from './constants';

export type SubmissionStatusRecord = {
  status?: string | null;
  deadLettered?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export const getSubmissionTimestamp = (statusRecord?: SubmissionStatusRecord): number | null => {
  const fallbackTimestamp = statusRecord?.updatedAt || statusRecord?.createdAt;

  if (!fallbackTimestamp) {
    return null;
  }

  const parsed = new Date(fallbackTimestamp).getTime();
  return Number.isNaN(parsed) ? null : parsed;
};

export const isSubmissionInFlight = (statusRecord?: SubmissionStatusRecord): boolean => {
  const status = statusRecord?.status;

  return (
    status === INVENTORY_REQUEST_SUBMISSION_STATUS.QUEUED ||
    status === INVENTORY_REQUEST_SUBMISSION_STATUS.PROCESSING ||
    (status === INVENTORY_REQUEST_SUBMISSION_STATUS.ERROR && !statusRecord?.deadLettered)
  );
};

export const isRecentSubmission = (
  statusRecord: SubmissionStatusRecord | undefined,
  maxAgeMs: number,
  now: number = Date.now()
): boolean => {
  const submissionTimestamp = getSubmissionTimestamp(statusRecord);

  return submissionTimestamp !== null && now - submissionTimestamp <= maxAgeMs;
};

export const shouldShowSubmissionInFlight = (
  statusRecord: SubmissionStatusRecord | undefined,
  maxAgeMs: number,
  now: number = Date.now()
): boolean => isSubmissionInFlight(statusRecord) && isRecentSubmission(statusRecord, maxAgeMs, now);
